import * as React from 'react';
import { connect } from 'react-redux';
import * as timeGreeting from 'time-greeting';
import * as moment from 'moment';
import { getBookingCounts } from '../redux/actions/bookings';
import {
  Hero,
  Subtitle,
  ActionCard,
  Card,
  RouteWrapper,
  Permission,
  Box,
  Title,
} from '../components';

interface Props {
  auth: any;
  dispatch: Function;
}

interface State {
  pendingHires: string;
  unassignedHires: string;
  readyHires: string;
  activeHires: string;
  onHoldHires: string;
  completeHires: string;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      pendingHires: '-',
      unassignedHires: '-',
      readyHires: '-',
      activeHires: '-',
      onHoldHires: '-',
      completeHires: '-',
    };
  }

  /**
   * Fetch hire counts for dashboard statistics
   */
  async componentDidMount() {
    const counts = await this.props.dispatch(getBookingCounts());
    const { PENDING, UNASSIGNED, READY, ACTIVE, COMPLETE } = counts.data;
    this.setState({
      pendingHires: PENDING,
      unassignedHires: UNASSIGNED,
      readyHires: READY,
      activeHires: ACTIVE,
      onHoldHires: counts.data['ON-HOLD'],
      completeHires: COMPLETE,
    });
  }

  render() {
    return (
      <RouteWrapper title="Dashboard" requireAuth>
        <Hero className="is-primary is-fullheight">
          <Subtitle>{moment().format('dddd Do MMMM')}</Subtitle>
          <Title>
            {timeGreeting()}, {this.props.auth.user.name} 👋
          </Title>
          <br />
          <Permission require="MANAGE_BOOKINGS">
            <>
              <div className="columns has-text-centered">
                <div className="column is-4">
                  <Card list link="/bookings/status/PENDING">
                    <strong className="has-text-primary is-size-2">
                      {this.state.pendingHires}
                    </strong>
                    <p className="has-text-grey">Pending Today</p>
                  </Card>
                </div>
                <div className="column is-4">
                  <Card list link="/bookings/status/UNASSIGNED">
                    <strong className="has-text-primary is-size-2">
                      {this.state.unassignedHires}
                    </strong>
                    <p className="has-text-grey">Unassigned</p>
                  </Card>
                </div>
                <div className="column is-4">
                  <Card list link="/bookings/status/READY">
                    <strong className="has-text-primary is-size-2">
                      {this.state.readyHires}
                    </strong>
                    <p className="has-text-grey">Ready to Go</p>
                  </Card>
                </div>
              </div>
              <div className="columns has-text-centered">
                <div className="column is-4">
                  <Card list link="/bookings/status/ACTIVE">
                    <strong className="has-text-primary is-size-2">
                      {this.state.activeHires}
                    </strong>
                    <p className="has-text-grey">Due Back</p>
                  </Card>
                </div>
                <div className="column is-4">
                  <Card list link="/bookings/status/ON-HOLD">
                    <strong className="has-text-primary is-size-2">
                      {this.state.onHoldHires}
                    </strong>
                    <p className="has-text-grey">Returns</p>
                  </Card>
                </div>
                <div className="column is-4">
                  <Card list link="/bookings/status/COMPLETE">
                    <strong className="has-text-primary is-size-2">
                      {this.state.completeHires}
                    </strong>
                    <p className="has-text-grey">Completed Today</p>
                  </Card>
                </div>
              </div>
            </>
          </Permission>
          <div className="columns">
            <div className="column is-6">
              <Box>
                <Permission require="MANAGE_BOOKINGS">
                  <ActionCard
                    title="History"
                    subtitle="View a historical calendar of events"
                    icon="calendar"
                    link="/history"
                  />
                </Permission>
                <Permission require="MANAGE_PAYMENTS">
                  <ActionCard
                    title="CRM"
                    subtitle="Manage companies and drivers"
                    icon="users"
                    link="/dashboard/crm"
                  />
                </Permission>
                <Permission require="MANAGE_SERVICE">
                  <ActionCard
                    title="Service Vehicles"
                    subtitle="Manage vehicles requiring servicing"
                    icon="truck"
                    link="/service"
                  />
                </Permission>
              </Box>
            </div>
            <div className="column is-6">
              <Box>
                <Permission require="MANAGE_BOOKINGS">
                  <ActionCard
                    title="Availabilities"
                    subtitle="View a 2-week block of available vehicles"
                    icon="calendar-plus-o"
                    link="/availabilities"
                  />
                </Permission>
                <Permission require="MANAGE_PAYMENTS">
                  <ActionCard
                    title="Accounting"
                    subtitle="Manage payments, pre-auths and banking exports"
                    icon="credit-card"
                    link="/dashboard/accounting"
                  />
                </Permission>
                <ActionCard
                  title="Statistics"
                  subtitle="View your booking statistics"
                  icon="line-chart"
                  link="/statistics"
                />
              </Box>
            </div>
          </div>
        </Hero>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Route);
